<template>
  <div class="set-address">
    <div class="modal set-address-modal">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />

      <div class="modal-card">
        <section class="modal-card-body">
          <p class="err-msg" v-if="error">{{ errorMsg }}</p>
          <div class="field is-grouped" style="margin-bottom: 3px">
            <p class="control is-expanded has-icons-left has-icons-right">
              <input
                style="display: none"
                type="address"
                name="fakeusernameremembered"
              />
              <input
                class="input is-medium"
                type="text"
                v-model="locationInput"
                ref="autocomplete"
                :placeholder="placeholderText"
                onfocus="value = ''"
                onpaste="return false;"
                ondrop="return false;"
                v-on:keyup="checkLength"
                autocomplete="hide-address-autofill"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-globe-asia" />
              </span>
              <span
                v-if="locationInput"
                class="icon is-small is-right"
                style="pointer-events: initial"
                @click="locationInput = null"
              >
                <i class="fa fa-times-circle" />
              </span>
            </p>
            <p v-if="!locationInput" class="control">
              <span
                class="button is-white is-medium"
                style="padding: 4px"
                @click="triggerPaste"
              >
                <a class="has-text-info"><i class="far fa-edit" /></a>
              </span>
            </p>
          </div>

          <!-- <span class="button is-pulled-right places-btn" @click="triggerPaste">
            <a class="has-text-link"><i class="far fa-edit" />&nbsp;lat,lon</a>
          </span> -->

          <div class="map-wrapper">
            <div :id="mapID" class="map">
              <div v-if="userCoords" class="leaflet-top leaflet-right">
                <div class="center-btn button is-rounded" @click="recenter">
                  <i class="fa fa-crosshairs" :class="{ 'fa-spin': spin }" />
                </div>
              </div>
            </div>
          </div>

          <div class="confirm-btn">
            <a
              class="button is-info is-medium is-fullwidth"
              @click="confirmLocation"
            >
              {{ $t("confirm-address") }}
            </a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";
import EventBus from "../eventBus.js";
import L from "leaflet";
import "leaflet.locatecontrol";
// import "leaflet-edgebuffer"; // commented out to decrease load time
import "leaflet.awesome-markers";

export default {
  name: "SetAddressModal",
  data() {
    return {
      mapID: "set-address-modal-map",
      map: undefined,
      marker: undefined,
      blueDot: null, // previously called userMarker
      // locateControl: undefined,
      error: false,
      errorMsg: "Select address from list or move map pin",
      locationInput: "",
      autocomplete: undefined,
      place: undefined, // google place result
      addressName: "",
      fullAddress: "",
      streetName: "",
      googleStreetName: "",
      active: false, // is map active?
      delay: true,
      callback: null,
      spin: false,
    };
  },
  computed: {
    placeholderText() {
      return this.$t("enter-location");
    },
    country() {
      if (!this.$store.state.selectedBusiness) return "th"; // default thailand
      return this.$store.state.selectedBusiness.country; // otherwise country of last business selected
    },
    userCoords() {
      return this.$store.getters.getUserLatLon; // getters.getUserLocation
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    console.log("mounted SetAddressModal");
    var url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(url, () => this.initGoogle());
    this.initMap();

    EventBus.$on("SET_ADDRESS_MODAL", (callback) => {
      console.log("SET_ADDRESS_MODAL callback:", callback);
      this.callback = callback;
      this.$nextTick(() => {
        this.map.invalidateSize(); // redraw map
        this.delay = true;
        setTimeout(() => (this.delay = false), 200); // short delay to stop infinite loop
        this.active = true;
        this.updateMarkerLocation(this.$store.getters.getUserLocation);
        this.geolocate(); // updates autocomplete bias
        this.updateAutocomplete(); // update autocomplete country
        this.updateUserMarkerLocation(); // new to update user position
        // if (this.locateControl) this.locateControl.start();
      });
    });
  },
  activated() {
    console.log("activated SetAddressModal");
  },
  beforeDestroy() {
    console.log("destroyed SetAddressModal");
  },
  methods: {
    closeModal() {
      if (this.blueDot) this.blueDot.closePopup();
      this.delay = true;
      // if (this.locateControl) this.locateControl.stop();
      this.locationInput = "";
      this.fullAddress = "";
      this.addressName = "";
      this.streetName = ""; // streetname from reverse geocode
      this.googleStreetName = ""; // backup streetname from google address lookup
      this.active = false;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    triggerPaste() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt'></i>&nbsp;Enter address coordinates
        </p>
        <p style='margin-bottom:12px'>
        You can manually enter the address coordinates if you know them.
        </p>
         <p style='margin-bottom:12px'>
        Enter as <code>lat,lon</code>
        </p>
        <p style='margin-bottom: 8px'>
        You can find the  coordinates on google maps by right clicking on the location. 
        </p>
       
        </div>`,
        input: "text",
        inputPlaceholder: "18.739951,98.9316323",
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 6 || txt.indexOf(",") === -1)
            return "Enter latitude,longitude";
        },
      }).then((val) => {
        if (val.value) {
          var nospace = val.value.replace(/ /g, "");
          var latString = nospace.split(",")[0];
          var lonString = nospace.split(",")[1];
          var lat = parseFloat(latString);
          var lon = parseFloat(lonString);
          var msg = `Incorrect format: [ ${val.value} ]<br>please enter latitude,longitude`;
          if (!lat || !lon) return this.errorToast(msg, "bottom", 6000);
          this.infoToast(lat + ", " + lon);
          this.updateMarkerLocation([lat, lon], true);
        }
      });
    },
    checkLength() {
      if (this.locationInput && this.locationInput.length > 15)
        this.error = true;
      else this.error = false;
    },
    updateAutocomplete() {
      var opt = { componentRestrictions: { country: this.country } }; // "sg", "th"
      if (this.autocomplete) this.autocomplete.setOptions(opt);
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [], // uses all, options are ["address", "establishment", "geocode"]
          componentRestrictions: { country: "th" }, // shouldn't be hard-coded after international expansion
        }
      );
      this.geolocate(); // will bias google places to current location

      this.autocomplete.addListener("place_changed", () => {
        this.error = false;
        var place = this.autocomplete.getPlace();
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        this.url = place.url;
        this.place = place;
        if (place.address_components) {
          if (place.address_components[0]) {
            this.googleStreetName = place.name; // place.address_components[0].long_name;
          }
        }

        this.locationInput = place.name; //place.types.join(", ");
        this.console(`The user picked ${name}`, place);
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        this.updateMarkerLocation([lat, lng]);
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate() {
      // if you have a location use that first
      var fallbackCoords = this.$store.getters.getUserLocationWithFallback;
      if (fallbackCoords) {
        this.biasAutocomplete(fallbackCoords[0], fallbackCoords[1]); // [lat, lon]
      }
      // then try to get updated location
      if (!navigator.geolocation) return; // FB in-app browser doesn't allow GPS
      navigator.geolocation.getCurrentPosition((position) => {
        var p = position.coords;
        this.biasAutocomplete(p.latitude, p.longitude);
      });
    },
    biasAutocomplete(lat, lon) {
      // console.log("biasAutocomplete", lat, lon);
      var circle = new google.maps.Circle({
        center: { lat: lat, lng: lon },
        radius: 25000, // I suspect this is null often, so better to hardcode to 25,000 m
      });
      this.autocomplete.setBounds(circle.getBounds());
      // this.autocomplete.setOptions({ strictBounds: true });
    },
    updateMarkerLocation(coords) {
      if (!this.marker || !coords) return;
      this.marker.setLatLng(coords);
      this.map.setView(coords, 17);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var initialLocation = this.$store.getters.getUserLocationWithFallback;
      if (!initialLocation) initialLocation = [13.73114, 100.57529]; // Bangkok Soi 41
      console.log("initialLocation", initialLocation);

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(initialLocation, 17);
      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 4,
        maxZoom: 19,
      }).addTo(this.map);

      // this.setupLocateControl();

      var icon = L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: "blue",
      });
      var iconDrag = L.AwesomeMarkers.icon({
        icon: "crosshairs",
        markerColor: "blue",
        spin: true,
      });

      this.marker = L.marker(initialLocation, { icon: icon }).addTo(this.map);
      this.marker.normalIcon = icon;
      this.marker.dragIcon = iconDrag;

      var popupOpts = { closeButton: false, autoPan: true };
      this.marker.bindPopup("<i>Confirm address?</i>", popupOpts);

      this.map.on("move", () => {
        if (!this.map || !this.marker || !this.active || this.delay) return;
        this.marker.setLatLng(this.map.getCenter());
      });
      this.map.on("dragstart", () => {
        this.marker.setIcon(this.marker.dragIcon);
      });
      this.map.on("moveend", () => {
        if (!this.map || !this.marker || !this.active) return;
        this.marker.setLatLng(this.map.getCenter()); // needed?
        this.marker.center = this.map.getCenter();
        this.marker.setIcon(this.marker.normalIcon);
      });

      if (this.userCoords) this.drawUserLocation();
    },
    drawUserLocation() {
      var coords = this.userCoords; // this.$store.getters.getUserLatLon;
      if (!coords) coords = [13.73114, 100.57529]; // Bangkok Soi 41
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [1, -6],
        className: "none",
      });
      this.blueDot = L.marker(coords, { icon: icon });
      this.blueDot.addTo(this.map);
      var popupOpts = { closeButton: false, autoPan: true };
      this.blueDot.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    recenter() {
      this.updateUserMarkerLocation(true);
      this.spin = true;
      setTimeout(() => (this.spin = false), 600);
    },
    updateUserMarkerLocation(flyTo) {
      if (!this.userCoords) return;
      this.blueDot.setLatLng(this.userCoords);
      if (flyTo) this.map.flyTo(this.userCoords);
      else this.map.setView(this.userCoords, 17);
    },
    confirmLocation() {
      // if (!this.checkMobileNumber()) return;
      var coords = this.marker.getLatLng();
      var loader = this.loadingDots();
      this.$store
        .dispatch("reverseGeocode", coords)
        .then((res) => {
          this.console("reverseGeocode", res);
          this.streetName = res.data.address.road;
          if (this.addressName === "") this.locationInput = this.streetName;
          // this.emitLocation(coords);
        })
        .catch((err) => console.error("reverseGeocode error", err))
        .finally(() => {
          loader.hide();
          this.emitLocation(coords); // moved here since it should emit even if err
        });
    },
    emitLocation(coords) {
      if (!this.streetName) this.streetName = this.googleStreetName;
      if (!this.streetName) this.streetName = "Pin Location";
      return this.reallyEmit(coords);
    },
    reallyEmit(coords, addressName) {
      console.log("reallyEmit", this.callback, addressName, coords);
      //   if (!addressName) addressName = this.addressName;
      var locationData = {
        name: this.parseStopName(addressName),
        address: this.fullAddress,
        lat: coords.lat,
        lon: coords.lng,
      };
      EventBus.$emit(this.callback, locationData);
      this.closeModal();
    },
    parseStopName(addressName) {
      if (!addressName) return this.streetName;
      if (!this.streetName) return addressName;
      return `${this.streetName}, ${addressName}`;
    },
    // setupLocateControl() {
    //   var clickBehavior = {
    //     inView: "setView",
    //     outOfView: "inView", //"setView",
    //     inViewNotFollowing: "inView",
    //   };
    //   var options = {
    //     position: "topright",
    //     icon: "fa fa-crosshairs",
    //     enableHighAccuracy: true,
    //     keepCurrentZoomLevel: true,
    //     flyTo: false, // was causing problem due to fake gps I think
    //     showPopup: false,
    //     drawCircle: false,
    //     drawMarker: true,
    //     showCompass: true,
    //     clickBehavior: clickBehavior,
    //     onLocationError: (err) => console.warn("locateControl", err),
    //   };
    //   this.locateControl = L.control.locate(options).addTo(this.map);
    //   // this.locateControl.start(); // centers map to user geolocation
    //   // this.locateControl.stopFollowing();
    // },
  },
};
</script>

<style scoped>
.map-wrapper {
  height: 60vh;
  width: 100%;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
  /* border: 1px solid lightgrey; */
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.7);
  border-radius: 3px;
  /* margin: -3px 0; */
}
input::-webkit-input-placeholder {
  color: #2693da !important;
  opacity: 0.8;
}
/* .input {
  border-radius: 0;
  border-top-left-radius: 25px;
} */
.modal-card-body {
  padding: 10px;
  max-width: 640px;
}
.confirm-btn {
  margin-top: 3px;
}
.center-btn.button {
  margin: 10px;
  padding: 0 9px;
  pointer-events: auto;
  /* color: rgb(0, 106, 255); */
}
.err-msg {
  color: var(--danger);
  margin-bottom: 3px;
}
/* .places-btn {
  top: -40px;
} */
</style>

<style lang="scss">
#set-address-modal-map {
  .leaflet-control-locate {
    border-radius: 50%;
  }
  .leaflet-control-locate a {
    border-radius: 50%;
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    // max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    // color: grey;
  }
  .blue-dot {
    margin-left: 0px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .pulse {
    // animation: shadow-pulse 2s infinite;
    animation: pulsate 3s ease-out infinite;
  }
  // @keyframes pulsate {
  //   0% {
  //     box-shadow: 0 0 0 yellow;
  //   }
  //   50% {
  //     box-shadow: 0 0 20px #2692da5f;
  //   }
  //   100% {
  //     box-shadow: 0 0 0 gold;
  //     // box-shadow: 0 0 0 #2692da5f;
  //   }
  // }
  @keyframes pulsate {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
  @-webkit-keyframes pulsate {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
}
</style>